import { Box, styled } from '@mui/material';

interface TimelineStatusProps {
  $statusLabelColor: string;
}

export const TimelineStyled = styled(Box)<TimelineStatusProps>(
  ({ $statusLabelColor, theme }) => ({
    '& .status-label': {
      fontWeight: 600,
      color:
        $statusLabelColor === '' ? theme.palette.info.main : $statusLabelColor,
    },
    marginTop: theme.spacing(8),
  })
);

export const TimelineDotStyled = styled(Box)<TimelineStatusProps>(
  ({ $statusLabelColor, theme }) => ({
    backgroundColor:
      $statusLabelColor === '' ? theme.palette.grey[300] : $statusLabelColor,
    width: '1.6rem',
    height: '1.6rem',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '100%',
  })
);

export const TimelineConnectorStyled = styled(Box)(({ theme }) => ({
  borderLeft: `1px solid ${theme.palette.grey['300']}`,
  height: '40px',
  margin: theme.spacing(1.25, 1.75),
}));

export const TimelineContentStyled = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(-2.5),
  marginLeft: theme.spacing(2),
}));
